/**
 * Flow Steps Configuration
 * Defines the multi-step form configuration for creating flows
 */

import { FLOW_TRIGGER, FlowTrigger } from './flowTriggers';

export const FLOW_STEPS = {
    NAME: 1,
    TRIGGER: 2,
    PRODUCT_OR_DATETIME: 3,
    AUDIENCE: 4,
} as const;

export type FlowStep = (typeof FLOW_STEPS)[keyof typeof FLOW_STEPS];

/**
 * Get total number of steps based on trigger type
 * Time-based triggers have 4 steps, others have 3
 */
export const getStepTotal = (triggerType: FlowTrigger): number => {
    return triggerType === FLOW_TRIGGER.TIME ? 4 : 3;
};

/**
 * Step titles for display
 */
export const STEP_TITLES: Record<FlowStep, string> = {
    [FLOW_STEPS.NAME]: 'Give your flow a name',
    [FLOW_STEPS.TRIGGER]: 'When do you want to start your email sequence?',
    [FLOW_STEPS.PRODUCT_OR_DATETIME]: 'Choose your product', // Dynamic based on trigger
    [FLOW_STEPS.AUDIENCE]: 'Who would you like to send this sequence to?',
};

/**
 * Get step title based on trigger type
 */
export const getStepTitle = (step: FlowStep, triggerType: FlowTrigger): string => {
    if (step === FLOW_STEPS.PRODUCT_OR_DATETIME) {
        return triggerType === FLOW_TRIGGER.TIME ? 'Select date and time' : 'Choose your product';
    }
    return STEP_TITLES[step];
};
